import React from "react";

/**
 * Table footer only:
 * Left  — Showing X to Y of Z
 * Right — Pagination
 * (Show entries lives in TableToolbar at the top.)
 */
export const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  totalEntries,
  entriesPerPage,
}) => {
  const safeTotal = Number(totalEntries) || 0;
  const safePerPage = Number(entriesPerPage) || 10;
  const startEntry = safeTotal === 0 ? 0 : (currentPage - 1) * safePerPage + 1;
  const endEntry = Math.min(currentPage * safePerPage, safeTotal);

  const getPageNumbers = () => {
    const pageNumbers = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else if (currentPage <= 3) {
      for (let i = 1; i <= 4; i++) pageNumbers.push(i);
      pageNumbers.push("...");
      pageNumbers.push(totalPages);
    } else if (currentPage >= totalPages - 2) {
      pageNumbers.push(1);
      pageNumbers.push("...");
      for (let i = totalPages - 3; i <= totalPages; i++) pageNumbers.push(i);
    } else {
      pageNumbers.push(1);
      pageNumbers.push("...");
      for (let i = currentPage - 1; i <= currentPage + 1; i++) {
        pageNumbers.push(i);
      }
      pageNumbers.push("...");
      pageNumbers.push(totalPages);
    }

    return pageNumbers;
  };

  return (
    <div className="xc-table-footer pagination-details-responsive">
      <div className="xc-table-footer__left">
        <p className="xc-table-footer__meta">
          Showing <span className="fw-semibold">{startEntry}</span> to{" "}
          <span className="fw-semibold">{endEntry}</span> of{" "}
          <span className="fw-semibold">{safeTotal}</span> entries
        </p>
      </div>

      <ul className="pagination pagination-separated pagination-sm mb-0">
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            type="button"
            className="page-link"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            aria-label="Previous page"
          >
            ‹
          </button>
        </li>

        {getPageNumbers().map((page, index) => (
          <li
            key={`${page}-${index}`}
            className={`page-item ${page === currentPage ? "active" : ""} ${
              page === "..." ? "disabled" : ""
            }`}
          >
            {typeof page === "number" ? (
              <button
                type="button"
                className="page-link"
                onClick={() => onPageChange(page)}
              >
                {page}
              </button>
            ) : (
              <span className="page-link">{page}</span>
            )}
          </li>
        ))}

        <li
          className={`page-item ${
            currentPage === totalPages || totalPages === 0 ? "disabled" : ""
          }`}
        >
          <button
            type="button"
            className="page-link"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages || totalPages === 0}
            aria-label="Next page"
          >
            ›
          </button>
        </li>
      </ul>
    </div>
  );
};
